import { render, staticRenderFns } from "./VeContainerSettings.vue?vue&type=template&id=b3025f90"
import script from "./VeContainerSettings.vue?vue&type=script&lang=js"
export * from "./VeContainerSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports